import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Form } from "reactstrap";
import { Table, TableRow } from "../../../components/Table";
import ToggleSwitch from "../../../components/Custom/Forms/ToggleSwitch/ToggleSwitch";
import ControlledDropDown from "../../../components/Custom/Forms/Controller/ControlledDropDown";
import { responseToaster } from "../../../helperFunctions";
import { useForm } from "react-hook-form";
import { DROPDOWN_ALL_VALUE, FILTER } from "../../../constant";
import { useRole } from "../../../redux/slices/authSlice";
import { setPayoutBlock } from "../../../redux/slices/withdrawalStatusCheckLiveSlice";
import { withdrawalStatusCheckLiveGetUpdate, withdrawalStatusCheckLiveGet, useWithdrawalStatusCheckLive } from "../../../redux/slices/withdrawalStatusCheckLiveSlice";
import { useDispatch } from "react-redux";

const isPayoutStsCheckRunningOptions = [
  {
    value: 1,
    label: "Yes",
  },
  {
    value: 0,
    label: "No",
  },
];

const WithdrawalStatusCheckLive = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [statusLoading, setStatusLoading] = useState(false);

  const withdrawalStatusCheckData = useWithdrawalStatusCheckLive();

  const initialValues = {
    isPayoutStsCheckRunning: "All",
  };

  const [filter, setFilter] = useState({ ...FILTER, isToast: false });
  const [filterColumns, setFilterColumns] = useState([]);
  const role = useRole("Withdrawal Status check Live");

  const onUpdateStatus = async (payload) => {
    try {
      setStatusLoading(payload?.id);
      const res = await dispatch(withdrawalStatusCheckLiveGetUpdate(payload)).unwrap();
      const index = withdrawalStatusCheckData?.data?.findIndex?.(
        (item) => item?.id === payload?.id
      );
      if (index > -1) {
        const newData = [...withdrawalStatusCheckData?.data];
        newData[index] = { ...newData[index], isPayoutStsCheckRunning: payload?.isPayoutStsCheckRunning };
        dispatch(
          setPayoutBlock({
            ...withdrawalStatusCheckData?.data,
            data: newData,
          })
        );
      }
      responseToaster(res);
      setStatusLoading(false);
    } catch (err) {
      setStatusLoading(false);
    }
  };

  const columns = [
    {
      title: "ID",
      name: "id",
    },
    {
      title: "pg Name",
      name: "pgName",
      Cell: (data) => {
        return data?.pgName;
      },
    },
    ...(role.includes("update-withdrawal-status-check-running") ? [{
      title: "IS Payout Status Check",
      name: "isPayoutStsCheckRunning",
      Cell: (data) => {
        return (
          <>
            {role.includes("update-withdrawal-status-check-running") ? (
              <ToggleSwitch
                isLoading={statusLoading === data?.id}
                value={data?.isPayoutStsCheckRunning ? 1 : 0}
                className={`${statusLoading ? "disabled" : ""}`}
                onChange={async (value, e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  try {
                    const payload = {
                      isPayoutStsCheckRunning: value,
                      id: data?.id,
                    };
                    await onUpdateStatus(payload);
                  } catch (err) { }
                }}
              />
            ) : null}
          </>
        );
      },
    }] : [])

  ];

  const onGet = async () => {
    setIsLoading(true);
    try {
      const {
        isFilter,
        isToast,
        page_no,
        limit,
        filter: dropdown,
        ...rest
      } = filter;
      const payload = isFilter
        ? {
          filter_data: {
            ...rest,
          },
          page_no,
          limit,
        }
        : {
          page_no,
          limit,
        };
      const res = await dispatch(withdrawalStatusCheckLiveGet(payload)).unwrap();
      if (isToast) {
        responseToaster(res);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("withdrawal-status-check-live")) {
      onGet();
    }
  }, [filter]);

  const onSubmit = async () => {
    const values = getValues();
    setFilter({
      ...filter,
      ...values,
      ...FILTER,
      isFilter: true,
      isToast: true,
    });
  };

  const { control, handleSubmit, getValues, reset } = useForm({
    defaultValues: initialValues,
  });


  if (!role.includes("withdrawal-status-check-live")) {
    return;
  }

  return (
    <>
      {role.includes("withdrawal-status-check-live") ? (
        <div className="support-log-main-div">
          <Card>
            <CardHeader className="flex-column  align-items-start">
              <div className="d-flex align-items-center w-100 justify-content-between">
                <h4 className="main-title">
                  <b>Withdrawal Status Check Live</b>
                </h4>
              </div>
            </CardHeader>
            <CardBody>
              <Form
                className="d-flex my-xl-auto right-content align-items-end button-space"
                style={{ flexWrap: "wrap" }}
                onSubmit={handleSubmit(onSubmit)}
              >
                <ControlledDropDown
                  name="isPayoutStsCheckRunning"
                  label="Is Payout Status Check"
                  isDefaultOption={DROPDOWN_ALL_VALUE}
                  options={isPayoutStsCheckRunningOptions}
                  control={control}
                />

                <Button type="submit" color="primary">
                  Apply
                </Button>
                <Button
                  type="button"
                  color="danger"
                  onClick={() => {
                    reset();
                    setFilter({ ...FILTER, isFilter: false, isToast: false });
                  }}
                >
                  Clear
                </Button>
              </Form>
            </CardBody>
          </Card>
          <Card>
            <Table
              columns={columns}
              isLoading={isLoading}
              data={withdrawalStatusCheckData?.data || []}
              isData={!!withdrawalStatusCheckData?.data?.length}
              filterColumns={filterColumns}
              count={withdrawalStatusCheckData?.total_item || 0}
              pagination={filter}
              isExpandable={false}
              handlePaginationChange={(pagination) => {
                setFilter({
                  ...filter,
                  ...pagination,
                  isToast: false,
                });
              }}
            >
              {withdrawalStatusCheckData?.data?.map?.((item) => {
                return (
                  <TableRow
                    columns={columns}
                    item={item}
                    filterColumns={filterColumns}
                    isExpandable={false}
                  />
                );
              })}
            </Table>
          </Card>
        </div>
      ) : null}
    </>
  );
};

export default WithdrawalStatusCheckLive;
